export default props => {
  const propsKeys = Object.keys(props)
  const keysLength = propsKeys.length

  return propsKeys.reduce((currentValue, key, index) => {
    const value = props[key]

    if (typeof value === 'boolean') {
      currentValue += `${value ? key : `not-${key}`}`
    } else if (typeof value === 'string' || typeof value === 'number') {
      currentValue += value
    } else {
      throw new Error('Values must be booleans, strings or numbers')
    }

    if (index !== keysLength - 1) {
      currentValue += ':'
    }

    return currentValue
  }, '')
}
